import '../stylesheets/main.scss';

import htmx from 'htmx.org';
import Alpine from 'alpinejs';

import 'photoswipe/style.css';

// @ts-ignore
import intersect from '@alpinejs/intersect';

// Alpine.js directives
// See https://alpinejs.dev/advanced/extending#custom-directives
import ResizeObserverDirective from './directives/resizeobserver';

// Alpine.js components
// See https://alpinejs.dev/globals/alpine-data#registering-from-a-bundle
import PasswordComponent from '../components/password/javascripts/index';
import ScrollContainerComponent from '../components/scroll-container/javascripts/index';
import FileUploadComponent from '../components/file-upload/javascripts/index';
import VideoComponent from '../components/video/javascripts/index';
import DialogComponent from '../components/dialog/javascripts/index';
import TabsComponent from '../components/tabs/javascripts/index';
import HeaderComponent from '../components/header/header';
import NavigationComponent from '../components/navigation/navigation';
import GalleryComponent from '../components/gallery/gallery';
import CompetenceViewComponent from '../components/competence-view/competence-view';
import ReadingProgressComponent from '../components/reading-progress/reading-progress';
import SearchListComponent from '../components/search-list/javascripts/index';
import SurveyComponent from '../components/survey/survey';
import TableComponent from '../components/table/table';
import WatchlistComponent from '../components/watch-list/javascripts/watch-list';
import WatchListLinkComponent from '../components/watch-list-link/watch-list-link';
import WatchlistBtnComponent from '../components/watchlist-btn/watchlist-btn';

// Alpine.js initialization
// See https://alpinejs.dev/essentials/installation#as-a-module
window.Alpine = Alpine;

// htmx initialization
// See https://htmx.org/docs/#webpack
window.htmx = htmx;

Alpine.plugin(intersect);

Alpine.directive('resizeobserver', ResizeObserverDirective);

Alpine.data('Password', PasswordComponent);
Alpine.data('ScrollContainer', ScrollContainerComponent);
Alpine.data('FileUpload', FileUploadComponent);
Alpine.data('Video', VideoComponent);
Alpine.data('Header', HeaderComponent);
Alpine.data('Navigation', NavigationComponent);
Alpine.data('Dialog', DialogComponent);
Alpine.data('Tabs', TabsComponent);
Alpine.data('Gallery', GalleryComponent);
Alpine.data('CompetenceView', CompetenceViewComponent);
Alpine.data('ReadingProgress', ReadingProgressComponent);
Alpine.data('SearchList', SearchListComponent);
Alpine.data('Survey', SurveyComponent);
Alpine.data('Table', TableComponent);
Alpine.data('WatchList', WatchlistComponent);
Alpine.data('WatchListLink', WatchListLinkComponent);
Alpine.data('WatchlistBtn', WatchlistBtnComponent);

Alpine.start();

// All links with target="_blank" attribute should have an attribute rel="noopener". This has performance and security reasons https://developers.google.com/web/tools/lighthouse/audits/noopener
document.querySelectorAll("[target='_blank']").forEach((link) => {
  link.setAttribute('rel', 'noopener');
});

// Get #cf-banner-show links and add cf open panel function on click
document.querySelectorAll("[href*='#cf-banner-show']").forEach((item) =>
  item.addEventListener('click', (e) => {
    e.preventDefault();
    window.CCM.openControlPanel();
  })
);
